import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from '../../components/Breadcrumb';
import useProducts from '../../hooks/useProducts';
import { addItemToCart } from '../../redux/slices/cartSlice';
import { toggleWishlistItem } from '../../redux/slices/wishlistSlice';
import { toggleCompareItem } from '../../redux/slices/compareSlice';
import { selectSortOrder } from '../../redux/selectors/productSelector';
import { sortProducts } from '../../utils/sorting';
import ProductSortSelect from '../../components/Select';
import SingleShop from '../../components/Shop';

const ShopColumnFourMain = () => {
  const { products, status, error } = useProducts(); // Use the custom hook to fetch product data and manage loading/error states
  const [sortedProducts, setSortedProducts] = useState([]);
  const sortOrder = useSelector(selectSortOrder); // Use the selector to get the sortOrder
  const dispatch = useDispatch();

  // Sorting products whenever the sort order or products change
  useEffect(() => {
    if (status === 'succeeded') {
      const sorted = sortProducts(products, sortOrder);
      setSortedProducts(sorted);
    }
  }, [products, sortOrder, status]);

  // Dispatch the action to add the item to cart
  const handleAddToCart = (product) => {
    dispatch(
      addItemToCart({
        product: product,
      })
    );
  };

  // Dispatch the action to toggle the item to wishlist
  const handleToggleWishlist = (product) => {
    dispatch(toggleWishlistItem(product));
  };

  // Dispatch the action to toggle the item to the Compare
  const handleToggleCompare = (product) => {
    dispatch(toggleCompareItem(product));
  };

  // Render a loading message while the products are being fetched
  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  // Render an error message if the fetch request fails
  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  return (
    <main>
      <Breadcrumb title="Shop Column 04" subTitle="Shop" />

      <div className="it-shop-area pt-120 pb-120">
        <div className="container">
          <div className="it-shop-top pb-15">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-6 mb-30">
                <div className="it-shop-text">
                  <span>
                    Showing 1-{sortedProducts.length} of {sortedProducts.length}{' '}
                    products
                  </span>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 mb-30">
                <div className="it-shop-select-box text-md-end">
                  <div className="it-shop-select p-relative">
                    <ProductSortSelect />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {sortedProducts.map((product) => (
              <div
                key={product.id}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30"
              >
                <SingleShop
                  productId={product.id}
                  thumbnailImg={product.thumbnail}
                  badgeTitle={product.badgeTitle}
                  title={product.title}
                  price={product.price}
                  rating={product.rating}
                  category={product.category}
                  images={product.images}
                  inStock={product.inStock}
                  onAddToCart={() => handleAddToCart(product)}
                  onToggleWishlist={() => handleToggleWishlist(product)}
                  onToggleCompare={() => handleToggleCompare(product)}
                />
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="it-pagination text-center mt-30">
                <nav>
                  <ul>
                    <li>
                      <Link to="#">1</Link>
                    </li>
                    <li className="current">
                      <Link to="#">2</Link>
                    </li>
                    <li>
                      <Link to="#">3</Link>
                    </li>
                    <li>
                      <Link className="current" to="#">
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ShopColumnFourMain;
